import { FieldModel } from "../../gen/FieldModel";
import { FieldModelWithYears } from "../../gen/FieldModelWithYears";

export class JisReport {
    public static open() {
        var div = $('<div>')
            .css('display', 'grid');
        var dialog = div
            .appendTo($("body"))
            .kendoDialog({
                visible: false,
                modal: true,
                title: ml('local:SelectJisReport'),
                actions: [
                    {
                        text: ml('local:DownloadJisReport'),
                        primary: true,
                        action: e => {
                            if (!(parseInt(yrDdl.value()) > 0 && parseInt(htDdl.value()) > 0 && parseInt(rDdl.value()) >= 0)) {
                                e.preventDefault();
                                return;
                            }
                            window.open(`/Jis/Report?report_id=${rDdl.value()}&revier_nr=${htDdl.value()}&jahr=${yrDdl.value()}`, '_blank');
                        },
                    },
                    {
                        text: ml('local:Cancel'),
                    }
                ],
                close: e => {
                    var wrapper = e.sender.wrapper;
                    kendo.destroy(wrapper);
                    wrapper.remove();
                }
            })
            .data('kendoDialog');
        dialog.wrapper.find('.k-dialog-title:first').attr('data-fullname', 'local:SelectJisReport');
        var download = dialog.wrapper.find('> .k-button-group:first > .k-button:eq(0)')
            .attr('data-fullname', 'local:DownloadJisReport')
            .toggleClass('k-state-disabled', true);
        dialog.wrapper.find('> .k-button-group:first > .k-button:eq(1)')
            .attr('data-fullname', 'local:Cancel');

        var yrDdl = $('<input>')
            .css('width', 300)
            .prependTo(dialog.element)
            .kendoDropDownList<FieldModel>({
                autoBind: true,
                optionLabel: ' ',
                dataTextField: 'Label',
                dataValueField: 'Value',
                filter: 'contains',
                change: e => {
                    download.toggleClass('k-state-disabled', !(parseInt(yrDdl.value()) > 0 && parseInt(htDdl.value()) > 0 && parseInt(rDdl.value()) >= 0));
                },
            }).data<FieldModel>('kendoDropDownList');
        yrDdl.enable(false);
        var htDdl = $('<input>')
            .css('width', 300)
            .prependTo(dialog.element)
            .kendoDropDownList<FieldModelWithYears>({
                autoBind: true,
                optionLabel: ' ',
                dataTextField: 'Label',
                dataValueField: 'Value',
                filter: 'contains',
                change: e => {
                    this.updateYear(rDdl, htDdl, yrDdl);
                    download.toggleClass('k-state-disabled', !(parseInt(yrDdl.value()) > 0 && parseInt(htDdl.value()) > 0 && parseInt(rDdl.value()) >= 0));
                },
                dataSource: new kendo.data.DataSource<FieldModelWithYears>({
                    type: 'aspnetmvc-ajax',
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false,
                    serverGrouping: false,
                    serverAggregates: false,
                    schema: {
                        data: 'Data',
                        total: 'Total',
                        errors: 'Errors',
                        model: {
                            id: "Value",
                        },
                    },
                    transport: {
                        read: {
                            //TODO: generate controller actions
                            url: '/Jis/GetHuntingTerritoryDescription',
                            dataType: "json",
                            type: 'POST',
                            cache: false,
                        },
                    }
                }),

            }).data<FieldModelWithYears>('kendoDropDownList');
        var rDdl = $('<input>')
            .css('width', 300)
            .prependTo(dialog.element)
            .kendoDropDownList<FieldModel>({
                autoBind: true,
                optionLabel: ' ',
                dataTextField: 'Label',
                dataValueField: 'Value',
                change: e => {
                    this.updateYear(rDdl, htDdl, yrDdl);
                    download.toggleClass('k-state-disabled', !(parseInt(yrDdl.value()) > 0 && parseInt(htDdl.value()) > 0 && parseInt(rDdl.value()) >= 0));
                },
                dataSource: new kendo.data.DataSource<FieldModel>({
                    type: 'aspnetmvc-ajax',
                    serverFiltering: false,
                    serverPaging: false,
                    serverSorting: false,
                    serverGrouping: false,
                    serverAggregates: false,
                    group: {
                        field: 'Group',
                    },
                    schema: {
                        data: 'Data',
                        total: 'Total',
                        errors: 'Errors',
                        model: {
                            id: "Value",
                        },
                    },
                    transport: {
                        read: {
                            //TODO: generate controller actions
                            url: '/Jis/GetReportDescriptions',
                            dataType: "json",
                            type: 'POST',
                            cache: false,
                        },
                    }
                }),

            }).data<FieldModel>('kendoDropDownList');
        dialog.open();
    }

    private static updateYear(rDdl: kendo.ui.DropDownList<FieldModel>, htDdl: kendo.ui.DropDownList<FieldModelWithYears>, yrDdl: kendo.ui.DropDownList<FieldModel>): any {
        var rItem = rDdl.dataItem();
        var htItem = htDdl.dataItem();
        if (rItem == null || !(rItem.Value >= 0) || htItem == null || !(htItem.Value > 0)) {
            yrDdl.value(null);
            yrDdl.enable(false);

            return;
        }
        yrDdl.value(null);
        yrDdl.enable(true);
        if (rItem.Group == 'Abschussplan') {
            yrDdl.setDataSource(new kendo.data.DataSource<FieldModel>({
                type: 'aspnetmvc-ajax',
                serverFiltering: false,
                serverPaging: false,
                serverSorting: false,
                serverGrouping: false,
                serverAggregates: false,
                schema: {
                    data: 'Data',
                    total: 'Total',
                    errors: 'Errors',
                    model: {
                        id: "Value",
                    },
                },
                transport: {
                    read: {
                        //TODO: generate controller actions
                        url: '/Jis/GetYears',
                        dataType: "json",
                        type: 'POST',
                        cache: false,
                    },
                }
            }));
        }
        else {
            var ds = new kendo.data.DataSource();
            ds.data(htItem.Years.map(num => {
                var model = new FieldModel();
                model.Label = num.toString();
                model.Value = num;
                return model;
            }));
            yrDdl.setDataSource(ds);
        }

    }

}